export default __webpack_public_path__ + "static/media/design.dc6c2300.svg";